export function wechatInnerBridgeReady(callback) {
  let bridge = window.WeixinJSBridge
  if (typeof bridge !== 'undefined') {
    callback(null, bridge)
  } else {
    document.addEventListener('WeixinJSBridgeReady', (bridge) => {
      callback(null, bridge)
    }, false)
  }
}
